/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum RoutineOccasionStatus {
  COMPLETED = "COMPLETED",
  FUTURE = "FUTURE",
  IN_PROGRESS = "IN_PROGRESS",
  IN_PROGRESS_EXPIRED = "IN_PROGRESS_EXPIRED",
  NOT_COMPLETED = "NOT_COMPLETED",
  REQUIRED_COMPLETED = "REQUIRED_COMPLETED",
}

export enum WidgetOverviewSize {
  TWO_X_FOUR = "TWO_X_FOUR",
  TWO_X_ONE = "TWO_X_ONE",
  TWO_X_THREE = "TWO_X_THREE",
  TWO_X_TWO = "TWO_X_TWO",
}

export enum WidgetWeatherCondition {
  BROKEN_CLOUDS = "BROKEN_CLOUDS",
  CLEAR_SKY = "CLEAR_SKY",
  FEW_CLOUDS = "FEW_CLOUDS",
  MIST = "MIST",
  RAIN = "RAIN",
  SCATTERED_CLOUDS = "SCATTERED_CLOUDS",
  SHOWER_RAIN = "SHOWER_RAIN",
  SNOW = "SNOW",
  THUNDERSTORM = "THUNDERSTORM",
}

export enum WidgetWeatherSize {
  ONE_X_ONE = "ONE_X_ONE",
  TWO_X_ONE = "TWO_X_ONE",
}

export interface StorecastFocusFileInput {
  fileId: string;
  pageId: string;
  scale?: number | null;
  transformX?: number | null;
  transformY?: number | null;
}

export interface StorecastFocusIntegrationIpoolInput {
  integrationIpoolWidgetId: string;
}

export interface StorecastFocusIntegrationPushAppyInput {
  integrationPushAppyWidgetId: string;
}

export interface StorecastFocusIssueOverviewInput {
  issueId?: string | null;
  issueWidgetId: string;
}

export interface StorecastFocusNoteInput {
  noteWidgetId: string;
  pageId?: string | null;
}

export interface StorecastFocusRoutineOverviewInput {
  routineId?: string | null;
  routineOverviewWidgetId: string;
}

export interface StorecastFocusSubjectInput {
  empty?: boolean | null;
  file?: StorecastFocusFileInput | null;
  integrationIpool?: StorecastFocusIntegrationIpoolInput | null;
  integrationPushAppy?: StorecastFocusIntegrationPushAppyInput | null;
  issueOverview?: StorecastFocusIssueOverviewInput | null;
  note?: StorecastFocusNoteInput | null;
  routineOverview?: StorecastFocusRoutineOverviewInput | null;
  routinePositivePercentage?: string | null;
  taskCollection?: string | null;
  taskSingle?: string | null;
  teamSchedule?: StorecastFocusTeamScheduleInput | null;
  todoOverview?: StorecastFocusTodoOverviewInput | null;
  weather?: string | null;
}

export interface StorecastFocusTeamScheduleInput {
  teamScheduleWidgetId: string;
}

export interface StorecastFocusTodoOverviewInput {
  todoId?: string | null;
  todoOverviewWidgetId: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
